import { Component, OnInit, input } from '@angular/core';
import { DynamicComponent } from '../dynamic/dynamic';
import { ContextService } from '../context.service';

@Component({
    selector: 'mutara-default-html',
    templateUrl: './default-html.component.html',
    standalone: false
})
export class DefaultHtmlComponent implements OnInit {
  readonly data = input<DynamicComponent>(undefined);
  constructor(private context : ContextService) { }

  ngOnInit(): void {
    this.context.changeMessage( 'raw HTML to be processed' );
  }

}
